import React, { Fragment } from "react";
import { Col } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import { OrderLists } from "../../../../Constant";
import { ORDER_LIST } from "../../../../Data/UiKit/Typography";
import { OrderListProps } from "../../../../Type/UiKits";

export const OrderListSecond = () => {
  return (
    <Col sm="12" xl="4">
      <div className="card-wrapper border rounded-3">
        <H6 className="sub-title fw-bold">{OrderLists}</H6>
        <dl className="pb-1">
          {ORDER_LIST.map((item: OrderListProps, index) => (
            <Fragment key={index}>
              <dt>{item.dt}</dt>
              <dd>{item.dd}</dd>
            </Fragment>
          ))}
        </dl>
      </div>
    </Col>
  );
};
